<template>
  <div class="loc-item" @click="onClick">
    <svg-check v-if="icon === 'check'" class="loc-item__check" :class="selectCheckClass" />
    <div class="loc-item__main loc-item__main-bg" :class="selectBgClass">
      <div class="loc-item__main-location">
        <span class="loc-item__main-content">{{ content }}</span>
        <span class="loc-item__main-district">{{ district }}</span>
      </div>
      <svg-arrow-right v-if="icon === 'arrow'" class="loc-item__main-arrow svg-fill" />
    </div>
  </div>
</template>

<script>
import { getDistrictLocaleKey } from '../../../libs/mapping/district'
import SvgArrowRightIcon from '../../../assets/svg/arrow_right.svg?inline'
import SvgCheck from '../../../assets/svg/check.svg?inline'

export default {
  components: {
    'svg-arrow-right': SvgArrowRightIcon,
    'svg-check': SvgCheck,
  },
  computed: {
    content() {
      return this.address.address || ''
    },
    district() {
      return this.$t(
        getDistrictLocaleKey({
          name: this.address.district_name,
        }),
      )
    },
    selectBgClass() {
      return {
        'loc-item__main--active': this.selected,
      }
    },
    selectCheckClass() {
      return {
        'loc-item__check--active': this.selected,
      }
    },
  },
  methods: {
    onClick() {
      if (this.enabled) {
        this.$emit('click')
      }
    },
  },
  props: {
    address: {
      default: () => ({}),
      type: Object,
    },
    enabled: {
      default: true,
      type: Boolean,
    },
    icon: {
      default: '',
      type: String,
    },
    selected: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="postcss" scoped>
.loc-item {
  @apply flex flex-row mb-4;
  @apply cursor-pointer;
}
.loc-item__check {
  @apply text-pink-light;
  @apply mr-3 mt-4;
  width: 32px;
  height: 32px;

  &.loc-item__check--active {
    @apply text-red-500;
  }
  & >>> circle {
    @apply fill-current;
  }
}
.loc-item__main {
  @apply relative flex flex-row rounded-lg w-full p-4;
  @apply items-center;
}
.loc-item__main-location {
  @apply flex flex-col flex-grow;
}
.loc-item__main-arrow {
  @apply flex-shrink-0;
  height: 44px;
  width: 44px;
}
.loc-item__main-bg {
  @apply bg-white-plain;

  &.loc-item__main--active {
    @apply border border-red-500;

    & >>> .loc-item__main-content {
      @apply text-red-500 font-bold;
    }
  }
  &:not (.loc-item__main--active) {
    @apply border border-red-50;
  }
  &:after {
    @apply absolute inset-0 bg-grey z-1;
    @apply rounded-md opacity-0 pointer-events-none;
    content: '';
    transition: opacity 0.2s ease;
  }
  &:hover:after {
    @apply opacity-10;
  }
}
.loc-item__main-content {
  @apply text-cbody2 font-cbody2 text-grey;
}
.loc-item__main-district {
  @apply text-cbody2 font-cbody2 text-grey-400;
}

@screen desktop {
  .loc-item__main-content {
    @apply text-cbody1 font-cbody1;
  }
}
</style>
